<template>
    <div class="order-item" @click="gotoDetail(data.orderNo)">
        <div class="status">
            <span><i></i>{{ data.orderNo }}</span>
            <em>{{ data.clientOrderStatusDes }}</em>
        </div>
        <div class="con">
            <div class="con-box">
                <img
                    :src="$config.QINIU_URL + data.orderDetailList[0].imgName"
                />
                <p>{{ data.orderDetailList[0].goodsName }}</p>
            </div>
        </div>
        <div class="other">
            <span>收货人：{{ data.linkmanName }}</span>
            <em
                >共{{ data.orderDetailList.length }}件商品
                <strong>
                    ¥<i>{{ data.orderMoney }}</i>
                </strong>
            </em>
        </div>
        <!--<div class="express">
            <p>已签收，感谢使用顺丰，期待再次为您服务</p>
            <span>2018-12-21 10:02:14</span>
        </div>-->
    </div>
</template>

<script>
export default {
    name: "OrderListItem",
    props: {
        data: {
            type: Object,
        },
    },
    methods: {
        /* 跳转详情页 */
        gotoDetail(orderNo) {
            this.$router.push({
                path: "/user/order/detail",
                query: { orderNo },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.order-item {
    padding-top: 20px;

    .status {
        background: #fff;
        padding: 0 30px;
        height: 80px;
        line-height: 80px;
        font-size: 28px;
        overflow: hidden;

        span {
            float: left;
            i {
                display: inline-block;
                width: 32px;
                height: 32px;
                background: url(../../../../public/images/order/order-icon.png)
                    center no-repeat;
                background-size: 100%;
                vertical-align: text-top;
                margin-right: 10px;
            }
        }

        em {
            float: right;
        }
    }

    .con {
        background: #fff;
        padding: 0 30px;

        .con-box {
            background: #f6f6f6;
            padding: 30px;
            border-radius: 4px;

            img {
                float: left;
                width: 100px; 
                height: 100px;
                margin-right: 14px;
            }

            p {
                font-size: 24px;
                height: 100px;
                line-height: 34px;
                margin-left: 14px;
                word-break: break-all;
                overflow: hidden;
            }
        }
    }

    .other {
        background: #fff;
        padding: 0 30px;
        height: 80px;
        line-height: 80px;
        font-size: 24px;
        overflow: hidden;

        span {
            float: left;
        }

        em {
            float: right;

            strong {
                font-weight: normal;
                color: #ff5500;
                margin-left: 20px;

                i {
                    font-style: normal;
                    font-size: 32px;
                }
            }
        }
    }

    .express {
        background: #fff;
        padding: 20px 30px;
        font-size: 24px;
        margin-top: 1px;

        p {
            color: #666;
        }

        span {
            display: inline-block;
            color: #999;
            margin-top: 10px;
        }
    }
}
</style>
